import { render } from "./TowerGame.vue?vue&type=template&id=8a806230"
import script from "./TowerGame.vue?vue&type=script&lang=js"
export * from "./TowerGame.vue?vue&type=script&lang=js"

import "./TowerGame.vue?vue&type=style&index=0&id=8a806230&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__